import { makeStyles } from '@material-ui/core/styles'
import { deepPurple } from '@material-ui/core/colors'

export default makeStyles((theme) => ({
   logout: {
      marginLeft: '20px',
   },

   purple: {
      color: theme.palette.getContrastText(deepPurple[500]),
      // top: '5%',
      left: '-10%',
      bottom: '20%',
      backgroundColor: '#0A9B9B',
   },

   /**
    * The chip when it is showing a real LOGO rather than an initial.
    *
    * Material-UI hard-codes `object-fit: cover` on the inner image, which is
    * right for a face and wrong for a logo: a wordmark gets scaled until it
    * fills the circle and then has its sides cropped off. The 3PL partner
    * chip was showing a Mocoo logo with the ends of the word cut away.
    *
    * The override has to be NESTED. `objectFit` on the root does nothing,
    * because the root is a div and the rule belongs to the <img> inside it.
    * Two classes deep also settles the specificity tie that a bare
    * `.MuiAvatar-img` would lose.
    *
    * White ground, because a contained logo letterboxes and most vendor
    * marks are dark artwork drawn for a light background. The dark ink
    * colour is for the case where the logo URL 404s: MUI then falls back to
    * the initial, which on the teal chip was white and would be invisible
    * here.
    */
   logoAvatar: {
      backgroundColor: '#FFFFFF',
      color: '#1F2937',
      padding: 3,
      boxSizing: 'border-box',
      left: '-10%',
      bottom: '20%',
      '& .MuiAvatar-img': {
         objectFit: 'contain',
      },
   },
}))
